import { useTranslation } from 'react-i18next';

import '../css/ChatHeader.css';

const LandingPage = ({ onSelectOption }) => {
  const { t } = useTranslation();

  return (
    <div>
      <>
        <div className="chatbot-body">
          <div className="img-logo-container">
            <img src="bg-chatbot-logo-unscreen-2.gif" className='bg-chatbot-logo-ani' alt="" srcset="" />
            <img src="/logo-chatbot.gif" className='logo-home-page' alt="" srcset="" />
          </div>
          <div className="msg-container">

            <div className="hello-msg">{t('Hello!')}</div>
            <div className="hint">{t('How can I Assist you today?')} </div>
            <div className="leave-balance-container">
              <ul className="leave-balance-list">
                <li className="leave-balance-item" onClick={() => onSelectOption('services')}>
                  <div className="main-icon">
                    <img src="./request.svg" alt="" />
                  </div>
                  <div className="title">{t('Make a Request')}</div>
                  <div className="go-icon">
                    <img src="./arrow-left.svg" alt="" />
                  </div>
                </li>
                <li className="leave-balance-item" onClick={() => onSelectOption('faqs')}>
                  <div className="main-icon">
                    <img src="./low-info.svg" alt="" />
                  </div>
                  <div className="title">{t('HR Law Information')}</div>
                  <div className="go-icon">
                    <img src="./arrow-left.svg" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="chatbot-footer">
          <div className="about-assistant">{t('Note: AI-generated legal outputs are indicative and must be reviewed and verified before official reliance.')}</div>
        </div>
      </>
    </div>
  );
};

export default LandingPage;
